<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="500" persistent>
    <v-card>
      <v-card-title>
        Unesi OIB za: {{ user && user.user ? user.user.name : '' }} {{ user && user.user ? user.user.surname : '' }}
      </v-card-title>

      <v-card-text>
        <v-form ref="form">
          <v-text-field
            v-model="oib"
            label="OIB"
            :rules="[rules.req(), rules.oib()]"
            outlined
            dense
            hide-details="auto"
          />

          <v-text-field
            v-model="pincode"
            label="PIN kod (4 cifre)"
            v-mask="'####'"
            class="mt-4"
            :rules="[
              rules.req(),
              rules.minLen(4),
              rules.maxLen(4),
              v => !isExistingPin || 'PIN već postoji'
            ]"
            @input="checkPinAvailability"
            outlined
            dense
            hide-details="auto"
          />

          <v-text-field
            v-model="designation"
            label="Oznaka operatera (opcionalno)"
            class="mt-4"
            outlined
            dense
            hide-details="auto"
          />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close" :disabled="submitting">Odustani</v-btn>
        <v-btn color="primary" @click="submit" :loading="submitting">
          Potvrdi
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from '@/plugins/rules'
import { df, functions } from '@/plugins/firebase'

export default {
  name: 'SetOibDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: null
    },
    companyId: {
      type: String,
      default: null
    },
    locationId: {
      type: String,
      default: null
    }
  },
  inject: ['showMsgBox'],
  data () {
    return {
      oib: '',
      pincode: '',
      designation: '',
      submitting: false,
      isExistingPin: false,
      rules
    }
  },
  watch: {
    value (newVal) {
      if (!newVal) {
        this.reset()
      }
    }
  },
  methods: {
    async checkPinAvailability () {
      if (this.pincode.length === 4) {
        try {
          const snapshot = await df
            .collection(`companies/${this.companyId}/users`)
            .where('user.pincode', '==', this.pincode)
            .where('user.status', '==', 'OK')
            .get()

          this.isExistingPin = !snapshot.empty
        } catch (error) {
          console.error('Error checking PIN availability:', error)
        }
      } else {
        this.isExistingPin = false
      }
    },
    validate () {
      return this.$refs.form.validate() && !this.isExistingPin
    },
    async submit () {
      if (!this.validate()) {
        this.showMsgBox({
          text: 'Molimo ispunite sva polja pravilno',
          color: 'error'
        })
        return
      }

      this.submitting = true

      try {
        const userApi = functions.httpsCallable('userapi')

        // Update korisnika sa OIB-om, PIN-om i oznakom
        await userApi({
          action: {
            operation: 'update',
            entity: 'user',
            resource_id: this.user.user.id,
            params: {
              oib: this.oib,
              pincode: this.pincode,
              designation: this.designation || '',
              roles: {
                ...this.user.user.roles,
                PRODAVAČ: true
              }
            }
          }
        })

        // Čekaj kratko da se update propagira
        await new Promise(resolve => setTimeout(resolve, 1000))

        // Dodaj korisnika na prodajno mjesto
        await userApi({
          action: {
            operation: 'set',
            entity: 'resource',
            params: {
              user_ids: [this.user.user.id],
              company_id: this.companyId,
              location_ids: [this.locationId],
              flag: 'add'
            }
          }
        })

        this.showMsgBox({
          text: `OIB je uspješno postavljen za ${this.user.user.name} ${this.user.user.surname}`,
          color: 'success'
        })

        // Emituj event da je OIB postavljen
        this.$emit('oibSet', this.user.user.id)
        this.close()
      } catch (error) {
        console.error('Error setting OIB:', error)
        this.showMsgBox({
          text: error.message || 'Dogodila se greška pri postavljanju OIB-a',
          color: 'error'
        })
      } finally {
        this.submitting = false
      }
    },
    close () {
      this.$emit('input', false)
    },
    reset () {
      this.oib = ''
      this.pincode = ''
      this.designation = ''
      this.isExistingPin = false
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    }
  }
}
</script>
